export var DEPLOY_DATE = new Date('2026-07-24T09:39:32+0000');
